import { render, staticRenderFns } from "./notification-component.vue?vue&type=template&id=45aafa1c&scoped=true&"
import script from "./notification-component.vue?vue&type=script&lang=ts&"
export * from "./notification-component.vue?vue&type=script&lang=ts&"
import style0 from "./notification-component.vue?vue&type=style&index=0&id=45aafa1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aafa1c",
  null
  
)

export default component.exports